var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M480,358.4V119.46L275.52,0v91.74l80.1,46.91c3.17,2.14,3.17,6.4,0,7.49l-94.88,55.46c-3.17,2.14-6.3,1.06-8.42,0 l-94.88-55.46c-3.17-1.09-3.17-6.4,0-7.49l80.13-46.91V0L32,119.46V358.4v-1.06v1.06l78.02-45.86v-93.89c0-3.2,4.19-5.31,6.3-4.26 l94.88,55.46c3.17,2.14,4.22,4.29,4.22,7.49v110.91c0,3.2-4.22,5.34-6.34,4.29l-80.1-46.94l-78.02,45.86L255.46,512l204.51-119.46 l-78.02-45.89l-80.06,46.94c-3.17,2.14-6.34,0-6.34-4.26V278.4c0-3.2,2.11-6.4,4.22-7.46l94.88-55.49c3.17-2.11,6.3,0,6.3,4.29 v93.86L480,358.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnity);
export default __webpack_public_path__ + "static/media/unity.73afefb37b0271fcfc8dba2f0bc4714e.svg";
export { ForwardRef as ReactComponent };